import { Routes } from '@angular/router';
import { LoginComponent } from '@auth/login.component';
import { LogoutComponent } from '@auth/logout.component';
import { AuthGuard } from '@auth/auth.guard';

import { StatementUploadsComponent } from '@components/statement-uploads/statement-uploads.component';
import { InputSheetsComponent } from '@components/input-sheets/input-sheets.component';
import { GroupRosterComponent } from '@components/group-roster/group-roster.component';
import { ParticipationComponent } from '@components/participation/participation.component';
import { KeyGraphComponent } from '@components/key-graph/key-graph.component';
import { ReportDownloadComponent } from '@components/report-download/report-download.component';
import { SupportComponent } from '@components/ResourseAndTools/support/support.component';
import { PdfViewerPageComponent } from '@components/pdf-viewer-page/pdf-viewer-page.component';
import { LayoutComponent } from '@components/layout/layout.component'; // ✅ add this
import { MyAnalystComponent } from './Components/my-analyst/my-analyst.component';
import { CustomReportComponent } from './Components/home/custom-report/custom-report.component';
import { PrintRequestComponent } from './Components/print-request/print-request.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },

  {
    path: '',
    component: LayoutComponent, // ✅ Wrap all protected routes with layout
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'Financial-Composite', pathMatch: 'full' },

      {
        path: 'Financial-Composite',
        children: [
          { path: '', redirectTo: 'KPI', pathMatch: 'full' },
          {
            path: 'Composite',
            loadComponent: () =>
              import(
                '@components/FinancialComposite/composite/composite.component'
              ).then((m) => m.CompositeComponent),
          },
          {
            path: 'KPI',
            loadComponent: () =>
              import('@components/FinancialComposite/kpi/kpi.component').then(
                (m) => m.KPIComponent,
              ),
          },
          {
            path: 'Objectives',
            loadComponent: () =>
              import(
                '@components/FinancialComposite/objective/objective.component'
              ).then((m) => m.ObjectiveComponent),
          },
          {
            path: 'Vitals',
            loadComponent: () =>
              import(
                '@components/FinancialComposite/vitals/vitals.component'
              ).then((m) => m.VitalsComponent),
          },
        ],
      },

      {
        path: 'Department-Analysis',
        children: [
          {
            path: ':department',
            loadComponent: () =>
              import(
                '@home/src/app/shared/components/department-view/department-view.component'
              ).then((m) => m.DepartmentViewComponent),
          },
        ],
      },

      // Standalone pages
      { path: 'Statement-Upload', component: StatementUploadsComponent },
      { path: 'Input-Sheet', component: InputSheetsComponent },
      { path: 'Group-Roster', component: GroupRosterComponent },
      { path: 'Participation', component: ParticipationComponent },
      { path: 'Key-Graph', component: KeyGraphComponent },
      { path: 'Report-Download', component: ReportDownloadComponent },
      { path: 'Resources-and-Tools/Support', component: SupportComponent },
      { path: 'My-Analyst', component: MyAnalystComponent },
      { path: 'Help', component: SupportComponent },
      { path: 'Print-Request', component: PrintRequestComponent },
      { path: 'Generate-Report', component: CustomReportComponent },
      { path: 'Pdf-Viewer', component: PdfViewerPageComponent },
    ],
  },
  // Global fallback
  { path: '**', redirectTo: 'Financial-Composite/KPI', pathMatch: 'full' },
];
